import React, { useEffect } from 'react';
import { useStore } from '../../../../../stores/root';
import { DatePicker, Dropdown, Stack } from '@fluentui/react';
import moment from 'moment';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IncomeInvoicesSummaryCard from './invoices';
import Label from '../../../../typography/label';
import Text from '../../../../typography/text';
import { IIncomeSummaryProps } from '../../../../../props/finance/incomes';
import IncomeService from '../../../../../services/finance/incomes';
import LoadingComponent from '../../../../feedbacks/loading';
import GeneralService from '../../../../../services/general';

// assets

// services

// props

// components

type IncomesSummaryCardProps = {
}



const IncomesSummaryCard: React.FC<IncomesSummaryCardProps> = (props: IncomesSummaryCardProps) => {
    const { banner, user } = useStore();

    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [summary, setSummary] = React.useState<IIncomeSummaryProps | undefined>();

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        setLoaded(false);
        const _summary = await IncomeService.summary();

        setSummary(_summary);
        setLoaded(true);
    }

    const renderCard = (title: string, value: string, color?: string) => {
        return <Stack className={'card'} styles={{root: {width: '25%'}}}>
            <Text size={'small'}>{title}</Text>
            {loaded && value !== '' ? <Label size={'xlarge'} className={`${color ? 'color-' + color : ''}`}>{value}</Label> : null}
            {!loaded || value === '' ? <Stack styles={{root: {paddingTop: 10}}}><LoadingComponent label={''} spinnerPosition={'baseline'} /></Stack> : null}
        </Stack>
    }

    return <Stack horizontal tokens={{childrenGap: 20}}>
        {renderCard('Amount Pending Verification', "Rp. " + GeneralService.getNumberWithSeparator(Number(summary?.pendingIncomes || '0')), 'yellow')}
        {renderCard('Unpaid Invoices', "Rp. " + GeneralService.getNumberWithSeparator(Number(summary?.unpaidIncomes || '0')), 'blue')}
        {renderCard('Overdue Invoices', "Rp. " + GeneralService.getNumberWithSeparator(Number(summary?.overdueIncomes || '0')), 'red')}
    </Stack>;
};

export default IncomesSummaryCard;
